/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleQueryEmailRecipients extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScheduleQueryEmailRecipients");
    }

    getFixupPrototypeFunction() { return ScheduleQueryEmailRecipients.fixupPrototype; }

    static newInstance(model: Partial<ScheduleQueryEmailRecipients>): ScheduleQueryEmailRecipients {
        let obj = Object.assign(new ScheduleQueryEmailRecipients(), model);
        ScheduleQueryEmailRecipients.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleQueryEmailRecipients>): ScheduleQueryEmailRecipients {
        if (!model) return null;
        return ScheduleQueryEmailRecipients.newInstance(<ScheduleQueryEmailRecipients> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleQueryEmailRecipients) {
        if (!obj) return;

        models.ScheduleQueryEmailRecipients.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleQueryEmailRecipients): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleQueryEmailRecipients.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Scheduled Notification Email Recipients
     */
    email_recipients: Array<string>;

}
